import { AddIcon, Button, Stack, useBreakpointDown } from '@all-manager/design-system-v2';
import FullPageLayout from "../../../layout/FullPageLayout/FullPageLayout";
import AddUpdateProviderModal from "../components/AddUpdateProviderModal/AddUpdateProviderModal";
import ManageProviderTagsModal from "../components/ManageProviderTagsModal/ManageProviderTagsModal";
import ProvidersList from "../components/ProvidersList/ProvidersList";
import { useProvidersListPage } from "./useProvidersListPage";

const floatingActionWrapperStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 24,
  right: 16,
  zIndex: 1000,
  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.16)',
  borderRadius: 8,
};

export default function ProvidersListPage() {
  const isMobile = useBreakpointDown('sm');
  const hook = useProvidersListPage();

  return (
    <>
      <FullPageLayout
        htmlTitle="Prestataires"
        title="Prestataires"
        subtitle={hook.subtitle}
        action={hook.isAdmin ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <Button
              variant="text"
              color="default"
              size="small"
              onClick={hook.handleOpenManageTagsModal}
            >
              Gérer les tags
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddIcon />}
              onClick={hook.handleOpenAddModal}
            >
              Nouveau prestataire
            </Button>
          </Stack>
        ) : undefined}
      >
        <ProvidersList />
      </FullPageLayout>

      {isMobile && hook.isAdmin ? (
        <div style={floatingActionWrapperStyle}>
          <Button
            variant="contained"
            size="medium"
            startIcon={<AddIcon />}
            onClick={hook.handleOpenAddModal}
          >
            Nouveau
          </Button>
        </div>
      ) : null}

      {hook.isAddModalOpened ? (
        <AddUpdateProviderModal
          onClose={hook.handleCloseAddModal}
          afterSuccess={hook.handleProviderCreated}
        />
      ) : null}

      {hook.isManageTagsModalOpened ? (
        <ManageProviderTagsModal
          onClose={hook.handleCloseManageTagsModal}
        />
      ) : null}
    </>
  );
}
